export class VenueCharge {
  id: number;
  chargeTypeId: number;
  chargeTypeName: string;
  chargeUnitId: number;
  quantityFrom: number;
  quantityTo: number;
  amount: number;
  venueId: number;
  isPercentage: boolean;
}



// WEBPACK FOOTER //
// ./src/app/core/models/venue-charge.ts